import { db } from '../firebase';
import { collection, getDocs, query, orderBy, where, limit, Firestore } from 'firebase/firestore';
import { BlogPost } from '../blog';

export async function getAllPosts(): Promise<BlogPost[]> {
    try {
        // Check if Firebase is initialized
        if (!db) {
            console.error('❌ Firebase not initialized');
            return [];
        }

        const firestoreDb: Firestore = db;
        const q = query(collection(firestoreDb, 'blog-posts'), orderBy('date', 'desc'));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as BlogPost));
    } catch (error) {
        console.error('Error fetching blog posts:', error);
        if (import.meta.env.DEV) {
            console.error('Error details:', error instanceof Error ? error.message : 'Unknown error');
        }
        return [];
    }
}

export async function getPostBySlug(slug: string): Promise<BlogPost | null> {
    try {
        // Check if Firebase is initialized
        if (!db) {
            console.error('❌ Firebase not initialized');
            return null;
        }

        const firestoreDb: Firestore = db;
        const q = query(collection(firestoreDb, 'blog-posts'), where('slug', '==', slug), limit(1));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            return null;
        }

        const doc = querySnapshot.docs[0];
        return { id: doc.id, ...doc.data() } as BlogPost;
    } catch (error) {
        console.error('Error fetching blog post:', error);
        if (import.meta.env.DEV) {
            console.error('Error details:', error instanceof Error ? error.message : 'Unknown error');
        }
        return null;
    }
}

